import React, { useState, useEffect } from "react";
import { Menu, X, Phone, Globe, Plane } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";

const Header = ({ onBookClick }) => {
  const { t, lang, toggleLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { key: "navTransfers", href: "#buscador" },
    { key: "navHotel", href: "#buscador" },
    { key: "navContact", href: "#contacto" },
  ];

  return (
    <header className="sticky top-0 z-50">
      {/* top bar */}
      <div className="hidden md:block bg-[#0d3b43] text-white/90 text-xs">
        <div className="max-w-7xl mx-auto px-6 h-9 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Phone className="w-3.5 h-3.5" />
            <span>+52 998 790 7699</span>
            <span className="opacity-50">|</span>
            <span>contact@rsvcancun.com</span>
          </div>
          <button
            onClick={toggleLang}
            className="flex items-center gap-1.5 hover:text-white transition-colors"
          >
            <Globe className="w-3.5 h-3.5" />
            <span className="uppercase font-semibold tracking-wide">
              {lang === "es" ? "Español" : "English"}
            </span>
            <span className="opacity-60">/ {lang === "es" ? "EN" : "ES"}</span>
          </button>
        </div>
      </div>

      {/* main nav */}
      <div
        className={`transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur rc-shadow" : "bg-white"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <a href="#top" className="flex items-center">
            <img
              src="/rsv-logo-trim.png"
              alt="RSV Transfers"
              className="h-11 w-auto"
            />
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.key}
                href={l.href}
                className="text-sm font-semibold text-[#0d3b43] hover:text-teal-600 transition-colors relative group"
              >
                {t(l.key)}
                <span className="absolute -bottom-1.5 left-0 w-0 h-0.5 bg-teal-500 group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={toggleLang}
              className="md:hidden flex items-center gap-1 text-xs font-bold text-[#0d3b43] border border-teal-200 rounded-full px-2.5 py-1"
            >
              <Globe className="w-3.5 h-3.5" />
              {lang.toUpperCase()}
            </button>
            <Button
              onClick={onBookClick}
              className="hidden sm:inline-flex bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-full px-5"
            >
              {t("bookNow")}
            </Button>
            <button
              className="lg:hidden text-[#0d3b43]"
              onClick={() => setOpen((o) => !o)}
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden border-t border-teal-100 bg-white px-6 py-4 space-y-3">
            {links.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block text-sm font-semibold text-[#0d3b43] py-1"
              >
                {t(l.key)}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
